/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t(t,r,a,e){var n;return"number"==typeof r?r:r.startsWith("-")||r.startsWith("+")?Math.max(0,t+parseFloat(r)):"<"===r?a:null!==(n=e.get(r))&&void 0!==n?n:t}export{t as calcNextTime};
//# sourceMappingURL=calc-time.js.map
